const PassFailBadge = ({ resolvedLogo, logoAlt, hasPassed }) => {
    return (
        <div
            className='br10px df fdc aic jcc pr'
            style={{
                width: '70px',
                height: '70px',
                border: '1px solid #E3E3E3',
                overflow: 'hidden',
                background: '#f9f9f9'
            }}
        >
            <img src={resolvedLogo} alt={logoAlt} style={{ width: '28px', height: '28px', objectFit: 'contain', marginBottom: '4px' }} />
            <span
                className='fw700 tac'
                style={{
                    fontSize: '10px',
                    color: hasPassed ? '#2e7d32' : '#c62828',
                    background: hasPassed ? '#e8f5e9' : '#ffebee',
                    borderRadius: '4px',
                    padding: '1px 5px',
                    lineHeight: '16px'
                }}
            >
                {hasPassed ? 'Passed' : 'Failed'}
            </span>
        </div>
    );
};

export default PassFailBadge;
